'use strict';

var FirebaseArray = require('./FirebaseArray');
var KayleeBase = require('./KayleeBase');
var KayleeCache = require('./KayleeCache');
var KayleeUtil = require('./KayleeUtil');

var KayleeUserMessages = {
	fromJson: fromJson,
	getUserMessages: getUserMessages,
};

function fromJson(data) {
	var reqProps = [ '$userId' ];
	return FirebaseArray.$fromJson(data, 'UserMessages', reqProps, reqProps,
		function(data) { return getUserMessages(data.$userId); }
	);
}

// Returns a promise that resolves to the UserMessages object when it is loaded.

function getUserMessages(userId) {
	var key = 'User Messages: ' + userId;
	var messages = KayleeCache.get(key);

	if (messages === null) {
		messages = new UserMessages(userId);
		KayleeCache.put(key, messages);
	}

	return messages;
}

function UserMessages(userId) {
	this.$nodeType = 'userMessages';
	this.$userId = userId;
	FirebaseArray.call(this,
		KayleeBase.app.database().ref('/messages/users/' + userId));
	KayleeUtil.bindPrototypeMethods(UserMessages.prototype, this, this.$items);
	this.$items.$self = this;
	return this.$items;
}

UserMessages.prototype = Object.create(FirebaseArray.prototype);
UserMessages.prototype.constructor = UserMessages;

UserMessages.prototype.$remove = function(key) {
	var update = {};
	update['/messages/users/' + this.$userId + '/' + key] = null;
	return KayleeBase.update(update);
};

UserMessages.prototype.$toJson = function() {
	return FirebaseArray.prototype.$toJson.call(this, [ '$userId' ], {});
};

UserMessages.prototype.toString = function() {
	return '[User messages for user (' + this.$id + ')]';
};

module.exports = KayleeUserMessages;